import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { validateString } from "src/utils/string/stringUtil";
import { showError, showSuccess, ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { deleteKSK2011_R01, deleteKSK2011_R01Work, downloadExcel_KSK2011_R01, getKSK2011_R01AllCount, getKSK2011_R01DetailList, getKSK2011_R01DetailMaterialList, getKSK2011_R01DetailProductList, getKSK2011_R01List, getKSK2011_R01WorkOne, getKSK2011_R01WorkStockOne, patchKSK2011_R01, patchKSK2011_R01Work, postKSK2011_R01, postKSK2011_R01Work } from "./Api_KSK2011_R01";
import { defaultKSK2011_R01Dto, defaultKSK2011_R01EditDto, KSK2011_R01DetailDto, KSK2011_R01Dto, KSK2011_R01EditDto } from "./Dto_KSK2011_R01";
import { defaultKSK2011_R01Filter, KSK2011_R01Filter, useKSK2011_R01Store } from "./Store_KSK2011_R01";
import { AgGridReact } from "ag-grid-react";
import { fetchDataSetHandler, fetchDataSetHandler_refetch, fetchFilterConfig, UpdateRowHandler } from "src/utils/grid/GridHandlerContent";
import useActionbarAuthStore from "src/store/useActionbarAuthStore";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { validateEmployeeCd } from "src/utils/grid/GridValidateContent";
import { useCommonCodeValidate } from "src/utils/commonCode/CommonCodeValidateContext";
import {
	buildCommonCodeRequirements,
	KSK2011_R01_ORDER_WORKPLACE_MESSAGE,
	KSK2011_R01_ROW_VALIDATE,
} from "src/utils/commonCode/commonCodeRequirementConfig";
import useUiuxStore from "src/store/useUiuxStore";
import { ProductWorkDto } from 'src/dtos/productWork/ProductWorkDto';
import { getMenuComponent } from "src/utils/menu/menuUtil";
import { getKSK2090_R01DetailList } from "../KSK2090_R01/Api_KSK2090_R01";
import { calculateTotalOrderQty } from "src/components/common/common";
import useMenuGlobalStore from "src/store/useMenuStore";


interface OrderContentProps {
	gridRef: React.RefObject<AgGridReact<KSK2011_R01Dto> | null>;
	detailGridRef: React.RefObject<AgGridReact<KSK2011_R01DetailDto> | null>;
	setMessage: (message: string) => void;  
	
}	


export const Content_KSK2011_R01 = (props: OrderContentProps) => {

	const { 
		gridRef,
		detailGridRef,
		setMessage,
	} = props;

	const {
		KSK2011_R01Filter, setKSK2011_R01Filter,
		KSK2011_R01PastFilter, setKSK2011_R01PastFilter,
		KSK2011_R01List, setKSK2011_R01List, 
		insertKSK2011_R01List, removeKSK2011_R01List,
		deletedKSK2011_R01List, addDeletedKSK2011_R01List, removeDeletedKSK2011_R01List,
		selectedKSK2011_R01List, setSelectedKSK2011_R01List, initSelectedKSK2011_R01List,
		originalKSK2011_R01List, setOriginalKSK2011_R01List,
		editKSK2011_R01, setEditKSK2011_R01,
		KSK2011_R01DetailList, setKSK2011_R01DetailList, 
		insertKSK2011_R01DetailList, removeKSK2011_R01DetailList,
		deletedKSK2011_R01DetailList, addDeletedKSK2011_R01DetailList, removeDeletedKSK2011_R01DetailList,
		selectedKSK2011_R01DetailList, setSelectedKSK2011_R01DetailList, initSelectedKSK2011_R01DetailList,
		originalKSK2011_R01DetailList, setOriginalKSK2011_R01DetailList,
		allCount, setAllCount,
		modalVisible, setModalVisible,
		initData,
	} = useKSK2011_R01Store();

	const {
		setConfirmModalVisible, setConfirmModalProps,
		addTabList, setActiveTab,
	} = useUiuxStore();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { compCdList, workPlaceList, jobTeamList, ordTypeList, employeeCdList, itemCdMap } = useCommonCodeStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();


	const setAuth = useActionbarAuthStore((state) => state.setAuth);



	// 권한 정보 로드
	useFetchActionbarAuth("KSK2011_R01");

	const getParams = (filter: Partial<KSK2011_R01Filter>) => {
		return {
			compCd: filter.compCd,
			workplaceCd: filter.workplaceCd,
			jobTeam: filter.jobTeam,
			dateRange: filter.dateRange,
			closeTag: filter.closeTag,
		}
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getKSK2011_R01AllCount(getParams(KSK2011_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [KSK2011_R01Filter, setAllCount]);

	const executeDataFetch = useCallback(async (fetchType: 'search' | 'refetch') => {
		setLoadingSpinner(true);
	
		let initialListLength = KSK2011_R01List.length;
		// 저장 후 재조회 시에는 목록을 비우기.
		if (fetchType === 'refetch') {
			setKSK2011_R01List([]);
		}

		const responseData = await getKSK2011_R01List(
			'',
			getParams(KSK2011_R01Filter),
			fetchType === 'refetch' ? initialListLength : KSK2011_R01List.length ?? 0
		);
	
		let newList = [...responseData.data.data ] as KSK2011_R01Dto[];
		setKSK2011_R01List(newList);
	
		const processAllCount = await renewalAllCount();
		setOriginalKSK2011_R01List(newList);
		setSelectedKSK2011_R01List(undefined);
		removeDeletedKSK2011_R01List(deletedKSK2011_R01List);
		gridRef.current?.api.ensureIndexVisible(0, 'top');
	
		if (newList.length === 0) {
			// insertKSK2011_R01List([{ ...defaultKSK2011_R01Row, inserted: true }], 0);
			showWarning('데이터가 없습니다.');
		} else {
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}
	
		setKSK2011_R01PastFilter(KSK2011_R01Filter);
		setLoadingSpinner(false);
	}, [
		KSK2011_R01Filter,  KSK2011_R01PastFilter, KSK2011_R01List, deletedKSK2011_R01List,
		gridRef, setMessage, setLoadingSpinner,
		setOriginalKSK2011_R01List, setSelectedKSK2011_R01List, initSelectedKSK2011_R01List, insertKSK2011_R01List,
	]);

	/**
	 * 사용자 목록 조회 함수
	 * 검색 조건에 맞는 사용자 목록을 가져옴
	 */
	const fetchData = useCallback(async () => {
		await executeDataFetch('search');
	}, [executeDataFetch]);
	
	const fetchWorkInfoData = useCallback(async (data: KSK2011_R01Dto): Promise<KSK2011_R01EditDto> => {
		if(!data) return defaultKSK2011_R01EditDto;

		const response = await getKSK2011_R01WorkOne(data.productOrderNo);
		const stockResponse = await getKSK2011_R01WorkStockOne(data.productOrderNo);

		//첫번째 케이스 : 작업지시에 공정정보가 하나도 없을때
		// response.data.data 항목이 없음
		// (beforeOrderQtySum 값은 0)
			//작업지시량(최대) : data.orderQty - beforeOrderQtySum 값이 작업지시량 최대값
			//작업지시량 : data.orderQty - beforeOrderQtySum 값이 작업지시량 최대값
		//두번째 케이스 : 작업지시에 공정정보가 있을때, 생산실적에 작업시작 버튼 안누름
		// response.data.data 항목이 있음
			//작업지시량(최대) : data.orderQty - beforeOrderQtySum 값이 작업지시량 최대값(beforeOrderQtySum 값은 작업시작 버튼 누른 공정지시 정보들의 생산지시량 합산값)
			//작업지시량 : response.data.data.orderQty 값(가장 최근에 등록한 공정지시 생산지시수량)
		//세번째 케이스 : 작업지시에 공정정보가 있을때, 생산실적에 작업시작 버튼 누름(다음 공정지시 입력해야할때)
		// response.data.data 항목이 없음
			//작업지시량(최대) : data.orderQty - beforeOrderQtySum 값이 작업지시량 최대값
			//작업지시량 : data.orderQty - beforeOrderQtySum 값이 작업지시량 최대값

		const beforeOrderQtySum = stockResponse.data.data.beforeOrderQtySum;
		const nowOrderQtyView = data.orderQty - beforeOrderQtySum;
		const nowInputOrderQty = response.data.data ? response.data.data.orderQty : data.orderQty - beforeOrderQtySum;

		// console.log('data.orderQty : ', data.orderQty);
		// console.log('response.data.data ? :', (response.data.data ? '있음' : '없음'));
		// console.log('beforeOrderQtySum :', beforeOrderQtySum);
		// console.log('nowOrderQtyView :', nowOrderQtyView);

		const editData: KSK2011_R01EditDto = {
			...defaultKSK2011_R01EditDto,
			...data,
			...response.data.data,
			productWorkNo: response.data.data?.productWorkNo || '',
			productOrderQtyView: nowOrderQtyView,		//작업지시정보의 작업지시량 표기
			orderQty: nowInputOrderQty,					//앞으로 등록할 공정지시정보의 작업지시량 표기
		}

		const workEmp = response.data.data?.workEmp || data.orderEmp || '';
		const workEmpNm = response.data.data?.workEmpNm || data.orderEmpNm || '';

		setEditKSK2011_R01({
			...defaultKSK2011_R01EditDto,
			...editData,
			workEmp: workEmp,
			workEmpNm: workEmpNm,
		});

		return editData;
	}, [editKSK2011_R01]);

	
	// const calculateTotalOrderQty = (orderQty: number, detailData: KSK2011_R01DetailDto) => {
	// 	return orderQty * detailData.childItemUsage + detailData.fixLossqty;
	// }
	
	const fetchDetailList = useCallback(async (data: KSK2011_R01EditDto) => {

		const responseData = (await getKSK2011_R01DetailList(data.itemCd)).data.data;
		const materialResponseData = (await getKSK2011_R01DetailMaterialList(data.itemCd)).data.data;
		const productResponseData = (await getKSK2011_R01DetailProductList(data.workplaceCd, data.itemCd)).data.data;
		if(responseData && responseData.length > 0){
			setKSK2011_R01DetailList(
				responseData.map((value: any, idx: any) => {
					//childItemCd값과 materialResponseData의 itemCd값이 일치하는 것의 stockQty값을 materialWarehouseQty에 저장
					const productWarehouseQty = productResponseData.find((product: any) => product.itemCd === value.childItemcd)?.stockQty ?? 0;
					const materialWarehouseQty = materialResponseData.find((material: any) => material.itemCd === value.childItemcd)?.stockQty ?? 0;
					const totalOrderQty = calculateTotalOrderQty(data.orderQty, value.childItemUsage, value.lossPercent, value.fixLossqty) || 0;
					const shortageQty = productWarehouseQty - totalOrderQty;

					return {
						...value,
						valueIndex: value.valueIndex ?? idx + 1,
						orderIndex: value.orderIndex ?? idx + 1,
						orderIndexSeq: value.orderIndexSeq ?? 0,
						productWarehouseQty : productWarehouseQty,
						materialWarehouseQty :materialWarehouseQty,
						shortageQty: shortageQty > 0 ? 0 : shortageQty,
						totalOrderQty :totalOrderQty,
					};
				})
			);
			setOriginalKSK2011_R01DetailList(responseData);
			detailGridRef.current?.api.ensureIndexVisible(0, 'top');
			setTimeout(() => setMessage(""), 5000);
		}else{
			showWarning('품목코드에 해당하는 BOM정보가 없습니다.');
			setKSK2011_R01DetailList([]);
			// 행추가 안함
			// insertKSK2011_R01DetailList([{ ...defaultKSK2011_R01DetailRow, orderIndex: responseData.length + 1, orderIndexSeq: 0, inserted: true }]);
		}
	}, [selectedKSK2011_R01List, KSK2011_R01DetailList, KSK2011_R01Filter, editKSK2011_R01])


	// 버튼 비활성화 상태 관리
	const [buttonDisabled, setButtonDisabled] = useState({
		fetch: false,      // 조회: 기본 활성화
		create: false,     // 생성: 기본 활성화
		delete: true,      // 삭제: 기본 비활성화
		save: true,        // 저장: 기본 비활성화
		print: true,       // 출력: 기본 비활성화
		excel: true,       // 엑셀: 기본 비활성화
		init: false        // 초기화: 항상 활성화
	});

	// 선택된 사용자와 삭제된 사용자가 변경될 때 버튼 상태 업데이트
	useEffect(() => {
		setButtonDisabled(prev => ({
			...prev,
			delete: deletedKSK2011_R01List.length === 0 && selectedKSK2011_R01List === null,
			save: KSK2011_R01List.length === 0,
			print: KSK2011_R01List.length === 0,
			excel: KSK2011_R01List.length === 0
		}));
	}, [selectedKSK2011_R01List, deletedKSK2011_R01List, KSK2011_R01List]);
	
	/**
	 * 엑셀 다운로드 핸들러
	 * 현재 검색 조건의 사용자 목록을 엑셀 파일로 다운로드
	 */
	const handleExcelClick = useCallback(async () => {

		const response = await downloadExcel_KSK2011_R01(
			'',
			getParams(KSK2011_R01Filter),
			KSK2011_R01List.length ?? 0
		);

		downloadSettingExcel({ responseData: response.data.data, fileName: '작업지시정보등록-excel.xlsx' });
	}, [KSK2011_R01Filter])
	
	const defaultKSK2011_R01Row = useCallback(() => {
		const workPlaceCdListToUse = workPlaceList.filter(
			opt => opt.useYn === 'Y' && opt.orderYn === 'Y',
		);

		const commonResult = validateCommonCodeLists([
			...buildCommonCodeRequirements(KSK2011_R01_ROW_VALIDATE, {
				compCdList,
				ordTypeList,
				workPlaceList,
				jobTeamList,
			}),
			{
				key: 'orderWorkPlaceList',
				list: workPlaceCdListToUse,
				message: KSK2011_R01_ORDER_WORKPLACE_MESSAGE,
			},
		]);

		if (!commonResult.valid) {
			return {
				...defaultKSK2011_R01Dto,
				inserted: true,
			};
		}

		return {
			...defaultKSK2011_R01Dto,
			compCd: compCdList[0].compCd,
			orderType: ordTypeList[0].minorCd,
			workplaceCd: workPlaceCdListToUse[0].workplaceCd,
			jobTeam: jobTeamList[0].minorCd,
			workProcess: workPlaceCdListToUse[0].workProcess,
			inserted: true,
		};
	}, [compCdList, ordTypeList, workPlaceList, jobTeamList, validateCommonCodeLists]);
	
	const handleSaveClick = useCallback(async () => {
		//조회 페이지
	}, [KSK2011_R01List, deletedKSK2011_R01List, originalKSK2011_R01List, executeDataFetch]);
	
	/**
	 * 삭제 핸들러
	 * 삭제 표시된 행이 있으면 복구, 없으면 선택된 행을 삭제 표시
	 */
	const handleDeleteClick = useCallback(() => {
		//조회 페이지
	}, [selectedKSK2011_R01List, deletedKSK2011_R01List, addDeletedKSK2011_R01List, removeDeletedKSK2011_R01List, setKSK2011_R01List, KSK2011_R01List]);



	const validateInsertData = (
		rowData: KSK2011_R01Dto,
		editData: KSK2011_R01EditDto,
		detailData: KSK2011_R01DetailDto[],
	) => {

		let warningMessage = '(지시No 조회필요)';
		
		if (!validateString(editData.productOrderNo)) {
			showWarning('지시No를 입력해주세요.'); return false;
		}
		if (!validateString(editData.compCd)) {
			showWarning('지시정보가 없습니다. 사업장을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(editData.workplaceCd)) {
			showWarning('공정명을 선택해주세요.' + warningMessage); return false;
		}
		if (!validateString(editData.itemCd)) {
			showWarning('품목코드를 입력해주세요.' + warningMessage); return false;
		}
		if (!itemCdMap.has(editData.itemCd)) {
			showWarning('품목코드가 존재하지 않습니다.' + warningMessage); return false;
		}
		if (!validateString(editData.workEmp)) {
			showWarning('담당자를 입력해주세요.' + warningMessage); return false;
		}
		if (!validateEmployeeCd(editData.workEmp, employeeCdList)) {
			showWarning('담당자가 존재하지 않습니다.(입력칸을 더블클릭하거나 엔터키로 세부사항을 열어서 지정해주세요)'); return false;
		}
		if(Number(editData.orderQty) > Number(editData.productOrderQtyView)) {
			showWarning('공정정보의 작업지시잔량이 현재 생성된 작업지시정보의 작업량보다 크게 설정되었습니다.'); return false;
		}
		if(Number(editData.orderQty) <= 0) {
			showWarning('작업지시잔량은 0보다 큰 값이어야 합니다.'); return false;
		}

		//detail 조회 후 검증
		let detailValid = true;
		// if(detailData.length === 0) {
		// 	showWarning('bom정보가 없습니다. bom 세부정보를 bom 등록 화면에서 등록해 주세요'); detailValid = false;
		// }
		// detailData.forEach(item => {
		// 	if(item.shortageQty < 0) {
		// 		showWarning('공정정보 생성에 필요한 재공창고의 자재수량이 부족합니다. 부족량이 0 이상이어야 합니다.'); detailValid = false;
		// 	}
		// });
		if(!detailValid) return false;
		return true;
	}

	const navigateToKSK2101 = useCallback(() => {
		const ksk2101Component = getMenuComponent('KSK2101_R01');
		if (!ksk2101Component) return;

		const menuNm = useMenuGlobalStore.getState().menuList.find(
			(menu) => menu.menuCd === 'KSK2101_R01'
		)?.menuNm;

		const newTab = {
			key: 'KSK2101_R01',
			title: menuNm || 'KSK2101_R01',
			component: ksk2101Component,
		};

		addTabList(newTab);
		setActiveTab(newTab);
	}, [addTabList, setActiveTab]);

	const completeWorkSave = useCallback(() => {
		const closeConfirmModal = () => {
			setConfirmModalVisible(false);
			setConfirmModalProps(undefined);
		};

		setConfirmModalProps({
			title: '알림',
			message: '지시등록이 완료되었습니다.\n공정배정 현황(KSK2101_R01) 화면으로 이동하시겠습니까?',
			confirmText: '네',
			cancelText: '아니오',
			onConfirm: () => {
				if (modalVisible) setModalVisible(false);
				closeConfirmModal();
				navigateToKSK2101();
			},
			onCancel: () => {
				if (modalVisible) setModalVisible(false);
				closeConfirmModal();
			},
		});
		setConfirmModalVisible(true);
	}, [modalVisible, setModalVisible, setConfirmModalVisible, setConfirmModalProps, navigateToKSK2101]);

	const handleWorkSaveClick = useCallback(async () => {

		const rowData = KSK2011_R01List.find(value => value.productOrderNo === editKSK2011_R01?.productOrderNo);
		if(!rowData) { showWarning('작업지시정보가 없습니다.'); return; }

		let valid = true;
		if(!validateInsertData(rowData!, editKSK2011_R01!, KSK2011_R01DetailList)) valid = false;
		if(!valid) return;

		let processName = '';
		let responseData: KSK2011_R01EditDto = {
			...editKSK2011_R01!,
		} as KSK2011_R01EditDto;
		let newKSK2011_R01EditDto: KSK2011_R01EditDto = {
			...defaultKSK2011_R01EditDto,
			...editKSK2011_R01!,
		} as KSK2011_R01EditDto;

		try {
			if (validateString(editKSK2011_R01?.productWorkNo || '')) {
				processName = 'patch';
				//수정 작업 실행
				const patchResponse = await patchKSK2011_R01Work(newKSK2011_R01EditDto);
				responseData = patchResponse.data.data;
				if(!patchResponse.data.successFlag) {
					showWarning('공정지시정보 수정에 실패하였습니다.');
					return;
				}else{
					showSuccess('지시등록되었습니다.');
					setMessage('지시등록이 완료되었습니다.');
					completeWorkSave();
				}
			}else{
				processName = 'post';
				//입력 작업 실행
				const postResponse = await postKSK2011_R01Work(newKSK2011_R01EditDto);
				responseData = postResponse.data.data;
				if(!postResponse.data.successFlag) {
					showWarning('공정지시정보 등록에 실패하였습니다.');
					return;
				}else{
					showSuccess('지시등록이되었습니다.');
					setMessage('지시등록이 완료되었습니다.');
					completeWorkSave();
				}
			}
		} catch (error) {
			console.error('공정지시정보 작업 중 오류가 발생했습니다.:', error);
			showError('공정지시정보 작업 중 오류가 발생했습니다.');
			return;
		}

		const responseProductWorkDto = {
			...responseData,
		} as KSK2011_R01EditDto;

		setEditKSK2011_R01({ ...responseProductWorkDto, });
		setModalVisible(false);
		setTimeout(() => {
			setMessage('');
		}, 5000)

	}, [KSK2011_R01List, editKSK2011_R01, KSK2011_R01DetailList, setModalVisible, setMessage, completeWorkSave]);

	
	const handleWorkDeleteClick = useCallback(async () => {
		if (!editKSK2011_R01?.productWorkNo) {
			showWarning('작업지시정보가 선택되지 않았습니다.'); return;
		}
		setLoadingSpinner(true);
		if (window.confirm('정말로 삭제하시겠습니까?')) {
			const response = await deleteKSK2011_R01Work(editKSK2011_R01?.productWorkNo || '');
			if(response.data.successFlag) {
				showSuccess(`${editKSK2011_R01?.productWorkNo} 작업지시정보 삭제가 완료되었습니다.`)
			}else{
				showWarning('작업지시정보 삭제에 실패하였습니다.');
				setLoadingSpinner(false);
				return;
			}
		}
		setLoadingSpinner(false);
		setModalVisible(false);
	}, [editKSK2011_R01, selectedKSK2011_R01List]);
	
	// OrderList가 변경될 때마다 원본 데이터 복사
	useEffect(() => {
		setOriginalKSK2011_R01List(JSON.parse(JSON.stringify(KSK2011_R01List)));
	}, [KSK2011_R01List]);


	return{
		fetchData,
		fetchWorkInfoData,
		// calculateTotalOrderQty,
		fetchDetailList,
		defaultKSK2011_R01Row,
		handleSaveClick,
		handleDeleteClick,
		handleExcelClick,
		buttonDisabled,
		handleWorkSaveClick,
		handleWorkDeleteClick,
	}
}
